export default __webpack_public_path__ + "static/media/photo--lg--kara9.d3f82b5c.jpg";